"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxesModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const ui_1 = require("../_abstract/ui");
const ui_2 = require("../_components/ui");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let BoxesModuleUi = class BoxesModuleUi extends ui_1.AbstractModuleUi {
};
BoxesModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'BoxesModuleUi',
        components: { ModuleHeaderUi: ui_2.ModuleHeaderUi },
        template: `
    <section class="boxes-module" :class="[moduleColoredClass, getThemeByBgClass]" :style="{ backgroundColor: customColor }">
      <div class="container">
        <div class="row">
          <div class="col">

            <!-- Heading -->
            <ModuleHeaderUi v-if="module.content.header" :header="module.content.header" />

            <!-- Boxes -->
            <ul v-if="module.content.boxes && module.content.boxes.length"
                class="boxes-module__list list-unstyled">
              <li v-for="(box, index) in module.content.boxes" :key="index"
                  class="boxes-module__list__item boxes-module__box">
                <!-- Heading -->
                <h3 v-if="box.heading" v-html="box.heading" class="boxes-module__box__heading" />

                <!-- Items -->
                <ul v-if="box.list && box.list.length" class="boxes-module__box__list list-unstyled">
                  <li v-for="(item, index) in box.list" :key="item + index" v-html="item" class="boxes-module__box__list__item" />
                </ul>

                <!-- Text -->
                <p v-if="box.text" v-html="box.text" class="boxes-module__box__text" />
              </li>
            </ul>
            <!-- END | Boxes -->

          </div>
        </div>
      </div>
    </section>
  `
    })
], BoxesModuleUi);
exports.BoxesModuleUi = BoxesModuleUi;
//# sourceMappingURL=Boxes.ui.js.map